import { TextInput } from 'components/forms/TextInput';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

// TextInput is styled as an underline field by default; this renders it as a bordered box instead.
export const ContainedTextInput = styled(TextInput)`
    box-sizing: border-box;
    padding: 0.3rem 0.7rem;
    border: 1px solid ${tokens.border.default};
    border-radius: 3px;
    background-color: ${tokens.input.background};

    &:focus,
    &:invalid {
        border: 1px solid ${tokens.border.focus};
        padding: 0.3rem 0.7rem;
    }

    /* TextInput's error state grows the border to 2px and only compensates padding-bottom
       (built for its default underline look); restore symmetric padding so a bordered box
       stays centered instead of shifting text toward the top. */
    &[aria-invalid='true'] {
        border-width: 1px;
        padding: 0.3rem 0.7rem;
    }
`;
